import * as Config from 'modules/utils/ConfigUtils';

export * from './configs.common';

export interface OAuthParams {
  tokenHost: string;
  tokenPath: string;
  audUrl?: string;
  authorizeHost?: string;
  authorizePath?: string;
  clientId?: string;
  clientSecret?: string;
  forgotUserPath?: string;
  landingUrl?: string;
  requestedScopes?: string[];
  redirectUrl?: string;
  revokePath?: string;
}

const createRedirectUrl = (path: string) => `${window?.location?.origin || ''}${path}`;
const createLandingUrl = (path: string) => `${window?.location?.origin || ''}${path}`;

/**
 * DFD PING Auth Configurations
 */
export const DFD_AUTH_CONFIG: OAuthParams = {
  authorizeHost: Config.AUTH_SERVER_BASE_URL,
  authorizePath: Config.AUTH_END_POINT_AUTHORIZATION,
  clientId: Config.AUTH_CLIENT_ID,
  clientSecret: Config.AUTH_SECRET,
  forgotUserPath: Config.AUTH_END_POINT_FORGOT_USERNAME,
  landingUrl: createLandingUrl('/landing'),
  redirectUrl: createRedirectUrl(Config.AUTH_REDIRECT_URL),
  requestedScopes: Config.AUTH_SCOPE,
  revokePath: Config.AUTH_END_POINT_REVOCATION,
  tokenHost: Config.AUTH_SERVER_BASE_URL,
  tokenPath: Config.AUTH_END_POINT_TOKEN
};
